import React, { useState, useEffect, useRef } from "react";

const Terminal = () => {
  const terminalOutput = [
    { text: `user@MacBook:~$ uv run src/run.py spot`, delay: 1000 },
    { text: `INFO:root:COCO found cam: 0`, delay: 500 },
    {
      text: `INFO:root:Webcam pixel dimensions for COCO: 1280, 720`,
      delay: 1500,
    },
    { text: `INFO:root:Initializing WebSim...`, delay: 1000 },
    { text: `INFO:root:Starting WebSim server thread...`, delay: 1200 },
    {
      text: `INFO:root:WebSim server started successfully - Open http://localhost:8000 in your browser`,
      delay: 1000,
    },
    {
      text: `INFO:root:VLM_COCO_Local: You see a person on your right. You also see a oven.`,
      delay: 1500,
    },
    { text: `INFO:root:LLM: Object Detector`, delay: 1000 },
    {
      text: `INFO:root:LLM: Input(input='You see a person on your right. You also see a oven.', timestamp=1741935095.1131089)`,
      delay: 1500,
    },
    {
      text: `INFO:root:OpenAI LLM input: You are a smart, curious, and friendly dog. Your name is Spot. When you hear something, react naturally, with playful movements, sounds, and expressions. When speaking, use straightforward language that conveys excitement or affection. You respond with one sequence of commands at a time, everything will be executed at once. Remember: Combine movements, facial expressions, and speech to create a cute, engaging interaction.`,
      delay: 2000,
    },
    { text: `INFO:root:SendThisToROS2: {'move': 'dance'}`, delay: 1500 },
    {
      text: `INFO:root:SendThisToROS2: {'speak': "Hello, it's so nice to see you! Let's dance together!"}`,
      delay: 1000,
    },
    { text: `INFO:root:SendThisToROS2: {'face': 'joy'}`, delay: 1000 },
    {
      text: `INFO:root:VLM_COCO_Local: You see a person in front of you.`,
      delay: 1500,
    },
    {
      text: `INFO:httpx:HTTP Request: POST https://api.openmind.org/api/core/openai/chat/completions "HTTP/1.1 200 OK"`,
      delay: 1000,
    },
    {
      text: `INFO:root:Inputs and LLM Outputs: {
  'current_action': 'wag tail', 
  'last_speech': "Hello, new friend! I'm so happy to see you!", 
  'current_emotion': 'joy', 
  'system_latency': {
    'fuse_time': 0.2420651912689209, 
    'llm_start': 0.24208617210388184, 
    'processing': 1.4561660289764404, 
    'complete': 1.6982522010803223}, 
  'inputs': [{
    'input_type': 'VLM_COCO_Local', 
    'timestamp': 0.0, 
    'input': 'You see a person in front of you.'}]
  }`,
      delay: 2000,
    },
  ];

  const [displayedLines, setDisplayedLines] = useState([]);
  const [hasStarted, setHasStarted] = useState(false);
  const terminalRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasStarted) {
          setHasStarted(true);
        }
      },
      { threshold: 0.5 }, // Trigger when 50% of the component is visible
    );

    const currentTerminalRef = terminalRef.current;

    if (currentTerminalRef) {
      observer.observe(currentTerminalRef);
    }

    return () => {
      if (currentTerminalRef) {
        observer.unobserve(currentTerminalRef);
      }
    };
  }, [hasStarted]);

  useEffect(() => {
    if (!hasStarted) return;

    let i = 0;

    const printNextLine = () => {
      if (i < terminalOutput.length) {
        setDisplayedLines((prevLines) => [
          ...prevLines,
          terminalOutput[i - 1].text,
        ]);
        setTimeout(printNextLine, terminalOutput[i].delay);
        i++;
      } else {
        // Ensure the last five lines exist before attempting to repeat
        if (terminalOutput.length >= 5) {
          const repeatLastFive = (index = 0) => {
            if (index < 5) {
              const lineIndex = terminalOutput.length - 5 + index;
              setDisplayedLines((prevLines) => [
                ...prevLines,
                terminalOutput[lineIndex].text,
              ]);
              setTimeout(
                () => repeatLastFive(index + 1),
                terminalOutput[lineIndex].delay,
              );
            } else {
              setTimeout(() => repeatLastFive(0), 2000); // Restart after a delay
            }
          };
          repeatLastFive();
        }
      }
    };

    printNextLine();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasStarted]);

  useEffect(() => {
    // Auto-scroll to bottom when a new line is added
    if (terminalRef.current) {
      terminalRef.current.scrollTop = terminalRef.current.scrollHeight;
    }
  }, [displayedLines]);

  return (
    <div className=" rounded-lg border border-gray-300 bg-white overflow-hidden shadow-lg h-full">
      {/* Header Section */}
      <div className="flex items-center bg-gray-100 px-4 py-2 border-b border-gray-300">
        {/* Buttons (Fake Window Controls) */}
        <div className="flex space-x-2">
          <div className="w-3 h-3 bg-red-500 rounded-full"></div>
          <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
        </div>
        {/* Title */}
        <div className="flex-1 text-center text-gray-600 text-sm font-medium">
          run spot
        </div>
      </div>

      {/* Terminal Output */}
      <div
        ref={terminalRef}
        className="p-4 text-black font-mono overflow-y-auto h-full"
        style={{
          whiteSpace: "pre-wrap",
          userSelect: "text",
          backgroundColor: "#f5f5f5",
        }}
      >
        {displayedLines.map((line, index) => (
          <div key={index}>{line}</div>
        ))}
      </div>
    </div>
  );
};

export default Terminal;
